import { render } from "./ModalDetailTransaction.vue?vue&type=template&id=38bc4607"
import script from "./ModalDetailTransaction.vue?vue&type=script&lang=js"
export * from "./ModalDetailTransaction.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__